import mcLib from './mc-lib';

export default function mcUserInfo(library, field = 'locale') {
  let marketingCloud = mcLib;
  if (library && typeof library.getUserInfo === 'function') {
    // if a valid library was passed
    marketingCloud = library;
  }
  return new Promise((resolve, reject) => {
    try {
      marketingCloud.getUserInfo(userInfo => {
        if (userInfo) {
          resolve(userInfo[field]);
        } else {
          reject();
        }
      });
    } catch (err) {
      console.error('Error calling getUserInfo', err);
    }
  });
}
